import { render, staticRenderFns } from "./RemoveGameList.vue?vue&type=template&id=e6fa5d38&scoped=true&"
import script from "./RemoveGameList.vue?vue&type=script&lang=js&"
export * from "./RemoveGameList.vue?vue&type=script&lang=js&"
import style0 from "./RemoveGameList.vue?vue&type=style&index=0&id=e6fa5d38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6fa5d38",
  null
  
)

export default component.exports